var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 128,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.165 9.197l.014 2.192c0 2.277-7.862 6.297-13.919 8.53l-2.012.744-.005 1.907v46.976c0 16.23 8.051 31.402 23.271 43.878a96.547 96.547 0 0023.128 14.033l1.358.538 1.362-.538a96.472 96.472 0 0023.124-14.033c15.225-12.476 23.27-27.648 23.27-43.878V20.671l-2.012-.744c-6.061-2.24-13-6.361-13-8.64v-2.09L48 0 16.165 9.197z",
    fill: "url(#crypto-locked_svg__paint0_linear_2430_55030)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 128V0l32.744 9.2v2.09c0 2.26 6.848 6.366 13 8.64l2.012.742v48.881c0 16.23-8.047 31.403-23.271 43.879a96.677 96.677 0 01-23.124 14.03L48 128z",
    fill: "#000",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.768 83.38H35.23c-1.76 0-3.024-.424-3.871-1.298-.86-.883-1.28-2.21-1.28-4.057v-19.26c0-2.92 1.676-4.918 4.483-5.343V46.8a17.848 17.848 0 011.111-6.459 12.726 12.726 0 012.973-4.562 12.297 12.297 0 014.29-2.703A14.338 14.338 0 0148 32.18a13.212 13.212 0 019.352 3.619 12.783 12.783 0 012.968 4.573 17.903 17.903 0 011.11 6.464v6.57c1.267.06 2.46.616 3.322 1.548a5.702 5.702 0 011.168 3.812v19.26c0 1.846-.418 3.173-1.28 4.056-.848.874-2.112 1.298-3.872 1.298zM44.375 72.419a1.146 1.146 0 00-1.152 1.152v.115a1.146 1.146 0 001.152 1.152h2.055v.883a1.148 1.148 0 001.152 1.152h.498a1.152 1.152 0 001.152-1.152v-6.72a4.87 4.87 0 002.266-1.604 4.346 4.346 0 00.941-2.813 4.59 4.59 0 00-4.608-4.608 4.586 4.586 0 00-4.608 4.609 4.344 4.344 0 00.941 2.812 4.87 4.87 0 002.266 1.604v3.418h-2.055zm3.661-35.914c-5.568 0-9.028 3.757-9.028 9.806v7.11H56.98l-.01-7.148c0-6.026-3.423-9.769-8.934-9.769zm-.205 29.386a1.28 1.28 0 11.056-2.56 1.28 1.28 0 01-.056 2.56z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "crypto-locked_svg__paint0_linear_2430_55030",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 148.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BCC17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B9C15"
  })))));
}
export default SvgCryptoLocked;